module.exports = __webpack_public_path__ + "img/weizhi.59a04e18.svg";